import routesLimited from '@/constants/routesLimited'
import type { RouteRecordRaw } from 'vue-router'

export const sendgreeting: RouteRecordRaw = {
	component: () =>
		import('components/templates/Datatable/Selected/SendGreeting.vue'),
	meta: {
		title: 'Zugangsdaten versenden',
		auth: true,
		limited: routesLimited.can_update,
		subs: [routesLimited.subMethods.notification_welcome],
	},
	name: 'sendGreeting',
	path: '/sendgreeting',
	props: true,
}
